import { logger } from '@gem/modules/logger';

import { SecretChatAccessRequestStatus } from 'APP/model/e2ee/e2eeModel.types';
import { e2eeModel } from 'APP/model/model';
import Entities from 'STORE';
import { SecretGroup } from 'STORE/Groups/SecretGroup/SecretGroup';

interface IBlockSecretGroupRequestAccessParams {
  deviceId: string;
  userId: string;
  groupId: string;
}

export const blockSecretGroupRequestAccess = async (
  params: IBlockSecretGroupRequestAccessParams
): Promise<{ result: boolean }> => {
  try {
    const secretGroup = Entities.GroupsStore.getGroupById(params.groupId);

    if (!secretGroup || !(secretGroup instanceof SecretGroup)) {
      return { result: false };
    }

    await e2eeModel.declineSecretChatAccessRequests(params);

    secretGroup.setDevicesRequestStatus(params.deviceId, SecretChatAccessRequestStatus.Declined);

    if (secretGroup.chatAccessRequestsCount !== 0) {
      secretGroup.setChatAccessRequestsCount(secretGroup.chatAccessRequestsCount - 1);
    }

    return { result: true };
  } catch (e) {
    logger.get('Tasks').error('e2ee.blockSecretGroupRequestAccess', e);
    return { result: false };
  }
};
